import { requireDefined } from '@nutrien/ddc-fe-util';
import { v4 as uuid } from 'uuid';

export const TransactionId = uuid();

function getRedirectUrl() {
  const port = window.location.port ? `:${window.location.port}` : '';
  return `${window.location.protocol}//${window.location.hostname}${port}/`;
}

const appConfig = {
  aws_project_region: requireDefined(import.meta.env.VITE_AWS_REGION),
  aws_cognito_identity_pool_id: requireDefined(import.meta.env.VITE_COGNITO_IDENTITY_POOL_ID),
  aws_cognito_region: requireDefined(import.meta.env.VITE_AWS_REGION),
  aws_user_pools_id: requireDefined(import.meta.env.VITE_COGNITO_USER_POOL_ID),
  aws_user_pools_web_client_id: requireDefined(import.meta.env.VITE_COGNITO_WEB_CLIENT_ID),
  Auth: {
    adfsFederatedIdentityProviderId: requireDefined(import.meta.env.VITE_OFFICE365_IDP),
    region: requireDefined(import.meta.env.VITE_AWS_REGION),
    userPoolWebClientId: requireDefined(import.meta.env.VITE_COGNITO_WEB_CLIENT_ID),
    userPoolId: requireDefined(import.meta.env.VITE_COGNITO_USER_POOL_ID),
    identityPoolId: requireDefined(import.meta.env.VITE_COGNITO_IDENTITY_POOL_ID),
    oauth: {
      office365IdentityProvider: requireDefined(import.meta.env.VITE_OFFICE365_IDP),
      domain: import.meta.env.VITE_COGNITO_DOMAIN,
      scope: ['email', 'profile', 'openid'],
      redirectSignIn: getRedirectUrl(),
      redirectSignOut: getRedirectUrl(),
      responseType: 'code',
    },
  },
  // Required for Amplify Storage module to work with S3 buckets
  Storage: {
    AWSS3: {
      bucket: requireDefined(import.meta.env.VITE_S3_BUCKET),
      region: requireDefined(import.meta.env.VITE_AWS_REGION),
    },
  },
  kinesisStreamName: requireDefined(import.meta.env.VITE_KINESIS_STREAM_NAME),
  logLevel: 'INFO',
};

export default appConfig;
